import * as Dialog from "@radix-ui/react-dialog";
import { X, LoaderCircle, AlertCircle, Check } from "lucide-react";
import type { ReactNode } from "react";
export function Modal({
  title,
  description,
  children,
  onClose,
  wide = false,
}: {
  title: string;
  description?: string;
  children: ReactNode;
  onClose: () => void;
  wide?: boolean;
}) {
  return (
    <Dialog.Root open onOpenChange={(v) => !v && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="bench-overlay" />
        <Dialog.Content
          className={"bench-modal " + (wide ? "wide" : "")}
          aria-describedby={description ? "bench-modal-description" : undefined}
        >
          <div className="modal-heading">
            <div>
              <Dialog.Title>{title}</Dialog.Title>
              {description && (
                <Dialog.Description id="bench-modal-description">
                  {description}
                </Dialog.Description>
              )}
            </div>
            <Dialog.Close className="b-icon" aria-label="Close">
              <X size={18} />
            </Dialog.Close>
          </div>
          <div className="modal-content">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
export function Field({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: string;
  children: ReactNode;
}) {
  return (
    <label className="b-field">
      <span>{label}</span>
      {children}
      {hint && <small>{hint}</small>}
    </label>
  );
}
export function ErrorBox({ error }: { error: unknown }) {
  return error ? (
    <div className="b-alert error" role="alert">
      <AlertCircle size={16} />
      <span>{error instanceof Error ? error.message : String(error)}</span>
    </div>
  ) : null;
}
export function Loading({ text = "Loading…" }: { text?: string }) {
  return (
    <div className="b-loading">
      <LoaderCircle className="spin" size={18} />
      {text}
    </div>
  );
}
export function Badge({
  children,
  tone = "neutral",
}: {
  children: ReactNode;
  tone?: string;
}) {
  return <span className={"b-badge " + tone}>{children}</span>;
}
export function CheckLine({
  children,
  checked,
  onChange,
}: {
  children: ReactNode;
  checked: boolean;
  onChange: (v: boolean) => void;
}) {
  return (
    <label className="b-check">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span>{children}</span>
    </label>
  );
}
export function Empty({
  title,
  children,
}: {
  title: string;
  children?: ReactNode;
}) {
  return (
    <div className="b-empty">
      <strong>{title}</strong>
      <p>{children}</p>
    </div>
  );
}
export function Success({ children }: { children: ReactNode }) {
  return (
    <div className="b-alert success">
      <Check size={16} />
      <span>{children}</span>
    </div>
  );
}
